

import { ArrowLongLeftIcon } from '@heroicons/react/20/solid'

export default function Breadcrumb(props) {
  return (
    <nav aria-label="Breadcrumb" className="flex border-b border-gray-200 bg-white">
      <ol className="mx-auto flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
        <li className="flex">
          <div className="flex items-center">
            <button
              onClick={() => {window.history.back();}}
              type="button"
              className="rounded-full bg-white-600 p-2 text-black shadow-sm hover:bg-white-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white-600"
            >
              <ArrowLongLeftIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0" fontSize={40} />
            </button>
          </div>
        </li>
        {
            props.pages ? 
                props.pages.map((page) => (
                    <li key={page.name} className="flex">
                        <div className="flex items-center">
                        <svg
                            fill="currentColor"
                            viewBox="0 0 24 44"
                            preserveAspectRatio="none"
                            aria-hidden="true"
                            className="h-full w-6 flex-shrink-0 text-gray-200"
                        >
                            <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                        </svg>
                        <button
                            aria-current={page.current ? 'page' : undefined}
                            className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                            {page.name}
                        </button>
                        </div>
                    </li>
                ))
            :
            null
        }
      </ol>
    </nav>
  )
}